// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"36924a3b","245":"4dbd3bc1"}[chunkId] + ".chunk.js";
};